import { z } from "zod";

export const trpcUtils = {
  isUnauthorized: (error: unknown) =>
    UnauthorizedErrorSchema.safeParse(error).success,
};

const UnauthorizedErrorSchema = z.object({
  data: z.object({
    code: z.literal("UNAUTHORIZED"),
  }),
});
